export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
export const CDN_CTRWOW_COMMON_LIB__BASE_URL = 'https://ctrwow-commonstorage.azureedge.net'
export const EDITOR_JS_LINK = `${CDN_CTRWOW_COMMON_LIB__BASE_URL}/public-assets/ctrwow_web_funnel/tinymce-5.5.1${process && process.env.NODE_ENV === 'development' ? '' : ''}/tinymce.min.js`;
